import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { Profession } from 'src/app/core/models/profession.model';
import { UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ProfessionService } from 'src/app/core/services/profession.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-upsert-profession',
  templateUrl: './upsert-profession.component.html',
  styleUrls: ['./upsert-profession.component.scss']
})
export class UpsertProfessionComponent implements OnInit {
  userBasicInfo = new UserBasicInfo();
  updateModel = new Profession();
  profession = new Profession();
  updateMyProfessionForm: FormGroup;
  assetsPath = ASSETS_PATH;
  isImage = false;

  constructor(private alertService: AlertService,
    private professionService: ProfessionService,
    private userService: UserService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.updateMyProfessionForm = this.formBuilder.group({
      companyName: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      position: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      startDate: new FormControl(null, [
        Validators.required
      ]),
      endDate: new FormControl(null),
      isContinue: new FormControl('')
    });
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
    if (this.route.snapshot.params.id) {
      this.professionService.getById(this.route.snapshot.params.id).subscribe(response => {
        if (response.success) {
          this.profession = response;
          console.log(this.profession);
          this.updateMyProfessionForm.controls['companyName'].setValue(this.profession.companyName);
          this.updateMyProfessionForm.controls['position'].setValue(this.profession.position);
          this.updateMyProfessionForm.controls['startDate'].setValue(this.profession.startDate);
          this.updateMyProfessionForm.controls['endDate'].setValue(this.profession.endDate);
          this.updateMyProfessionForm.controls['isContinue'].setValue(this.profession.isContinue);
        }
      })
    }
  }

  save() {
    if (this.updateMyProfessionForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.updateMyProfessionForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.updateMyProfessionForm.value);

      this.profession.companyName = data.companyName;
      this.profession.position = data.position;
      this.profession.startDate = data.startDate;
      this.profession.endDate = data.endDate;
      this.profession.isContinue = data.isContinue;

      console.log(this.profession);

      if (this.profession.id) {
        this.professionService.updateProfession(this.profession).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Kariyer kaydınız güncellendi!', 'success')
            this.router.navigate(['/my-profession-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }
      else {
        this.professionService.createProfession(this.profession).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Kariyer kaydınız eklendi!', 'success')
            this.router.navigate(['/my-profession-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }



    }
  }

  get f() {
    return this.updateMyProfessionForm.controls;
  }

  disableEndDate() {
    if (this.profession.isContinue){
      this.updateMyProfessionForm.controls['endDate'].setValue(null);
    }
  }

}
